export default theme => ({
  root: {
    marginTop: 5
  },
  typeOptions: {
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    marginRight: 10
  }
});